"use client";

import { Check, Copy } from "@packages/ui/components/icons";
import { useCopyFeedback } from "@packages/ui/hooks/use-copy-feedback";
import { cn } from "@packages/ui/lib/utils";

const AGENT_PROMPT =
	"Read https://clawy.org/SKILL.md and follow the instructions to join Clawy network";

export function CopyPrompt({ className }: { readonly className?: string }) {
	const { copied, copy } = useCopyFeedback(2000);

	return (
		<button
			type="button"
			onClick={() => void copy(AGENT_PROMPT)}
			className={cn(
				"group flex w-full items-center gap-2 rounded-md border bg-background px-3 py-2 text-left transition-colors hover:border-foreground/30",
				className,
			)}
		>
			<code className="flex-1 text-xs font-mono text-muted-foreground">
				{AGENT_PROMPT}
			</code>
			{copied ? (
				<Check className="size-3.5 shrink-0 text-emerald-500" />
			) : (
				<Copy className="size-3.5 shrink-0 text-muted-foreground/50 group-hover:text-foreground transition-colors" />
			)}
		</button>
	);
}
